import { h, Component } from 'preact'
import { connect } from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import constants from '../constants'
import util from '../util';
import MenuObject from "../canvas/menu-object";
import Renderer from '../canvas/renderer';

export default @connect(reduce, actions)
class MONotesBorderWidget extends Component {
  constructor() {
    super();

    this.getColorCss = () => {
      const $element = this.props.$element;
      if (!$element) return;
      return util.getMONotesLineColor($element);
    }

    this.applyToAll = () => {
      const $element = this.props.$element;
      if (!$element) return;
      window.ConfirmationModal.show({
        title: 'Are you sure?',
        body: 'This will apply the current group notes line settings to the entire menu.',
        acceptLabel: 'Yes, apply to all',
        declineLabel: 'Cancel',
        onAccept: () => {
          MenuObject.applyToAll($element, MenuObject.applyModes.notesBorder);
        },
        onDecline: () => {
          window.ConfirmationModal.hide()
        }
      });
    }

    this.updateMONotesLineWidth = this.updateMONotesLineWidth.bind(this);
  };

  updateMONotesLineWidth(ev) {
    const val = ev.target.value;
    const width = val / 10 + 'em';
    const color = this.props.moNotesLineColor;

    const patch = { type: 'mo-notes', key: 'border-bottom', value: `${width} solid ${color}` };
    MenuObject.patchStyles(this.props.isMultiSelect ? this.props.$elements : this.props.$element, patch);

    this.props.updateElementAttribute('moNotesLineWidth', val);
  }

  render(props, state) {
    return (
      <div className="dropdown">
        {!this.props.isFromAside && <a className="dropdown-toggle icn rwd-icon">Border</a>}
        <div className={`${!this.props.isFromAside ? 'dropdown-menu' : ''} border-mo`} data-close="no">
          <div className={'position-header'}>Line</div>
          <div className={'apply-to-all btn secondary1'} onClick={() => this.applyToAll('fill')}>Apply to all</div>
          <ul className="slider-list">
            <li className="color-item">
              <div className="border-color">
                <label>Color</label>
                <div onClick={() => this.props.openColorPicker(constants.pickerTypes.moNotesLine)}>
                  <span className="color-box" style={`background: ${this.getColorCss()}; float: none;`}></span>
                </div>
              </div>
            </li>
            <li className="slider-item">
              <div className={'slider-wrap'}>
                <label>Width</label>
                <div className="toolbar-wrap">
                  <input className="slider" type="range" min="0" max="25" step="1" value={this.props.moNotesLineWidth} onChange={this.updateMONotesLineWidth} onMouseMove={this.updateMONotesLineWidth} />
                </div>
                <input className="value" type="number" min="0" max="25" step="1" disabled="disabled" value={this.props.moNotesLineWidth} />
              </div>
            </li>
          </ul>
        </div>
      </div>);
  };
}
